import { Forms } from '@shared/utils';

export const routeToEcashPayments = (id?: number | undefined | null, formMode = Forms.PageConsult) => {
  if (id && formMode) {
    return [`/eCashPayments/${formMode}/${id}`];
  }
  return ['/eCashPayments'];
};
